import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { emptyUser, IPremiumDetail, IUser } from '@/models';
import { SLICE_NAMES } from '../constants';

const initialState: IUser = { ...emptyUser };

const userSlice = createSlice({
  name: SLICE_NAMES.USER,
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<IUser>) => {
      return { ...state, ...action.payload };
    },
    logout: state => {
      return { ...state, ...initialState };
    },
    setIsPremium: (state, action: PayloadAction<boolean>) => {
      return { ...state, isPremium: action.payload };
    },
    setPremiumDetails: (state, action: PayloadAction<IPremiumDetail>) => {
      return { ...state, premiumDetails: action.payload };
    },
  },
});

export const { setUser, logout, setIsPremium, setPremiumDetails } =
  userSlice.actions;

export const userReducer = userSlice.reducer;
